import InvoicesStore from "./Invoices/Invoices.Store";
import { RootStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const salesRoute: RouteType = {
  name: "Invoices",
  path: "/accounting/invoices",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Invoices",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./Sales.Header"),
    },
    body: {
      component: () => import("./Sales.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  // permissionPath: "accounting.sales",
  enableAutoFind: false,
  // channels: [":tab"],
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    // const tab = params.tab || "invoices";

    // if (tab === "invoices") {
    const invoicesStore = rootStore.invoicesViewStore as InvoicesStore;
    await invoicesStore.loadInvoices();
    // } else if (tab === "customers") {
    // const customersStore = rootStore.customersViewStore as CustomersStore;
    // await customersStore.loadCustomers();
    // }

    return true;
  },
  onParamsChange: async ({ rootStore }: { rootStore: RootStore }) => {
    const invoicesStore = rootStore.invoicesViewStore as InvoicesStore;
    await invoicesStore.loadInvoices();
  },
  dialogs: [
    {
      name: "invoiceForm",
      component: () => import("./SalesDialogs/CreateInvoiceDialog.Body"),
      title: "Invoice Form",
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const invoicesStore = rootStore.invoicesViewStore as InvoicesStore;
        const formData = invoicesStore.invoiceFormData;

        // Convert form data for submission
        const submitData = {
          ...formData,
          subtotal: formData.subtotal ? Number(formData.subtotal) : 0,
          taxAmount: formData.taxAmount ? Number(formData.taxAmount) : 0,
          totalAmount: formData.totalAmount ? Number(formData.totalAmount) : 0,
          amountPaid: formData.amountPaid ? Number(formData.amountPaid) : 0,
          amountDue: formData.amountDue ? Number(formData.amountDue) : 0,
        };

        const result = await invoicesStore.createInvoice(submitData);
        return !!result;
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const invoicesStore = rootStore.invoicesViewStore as InvoicesStore;
        const formData = invoicesStore.invoiceFormData;

        if (!formData.invoiceNumber) return false;
        if (!formData.lineItems || formData.lineItems.length === 0)
          return false;

        // Check if all line items have required fields
        const hasValidLineItems = formData.lineItems.every(
          (item) => item.description && item.quantity > 0 && item.unitPrice >= 0
        );
        if (!hasValidLineItems) return false;

        return true;
      },
      height: 1000,
    },
    {
      name: "invoiceDetails",
      component: () => import("./SalesDialogs/InvoiceDetailsDialog.Body"),
      title: "Invoice Details",
      cancelButton: true,
      height: 1200,
    },
  ],
};

export default salesRoute;
